import { UserInput, UserInputSource } from "@/contexts/WebSocketContext";

export const userInputToText = (userInput: UserInput): string => {
  if (userInput.source === UserInputSource.FILE) {
    return `arquivo ${userInput.file.name}`;
  }

  return "texto";
};
